<!----
    Author: hjlee
    Description:
        추가 필드 정보 컨트롤
---->
<template>
  <div class="additional-field-info-control">
    <div class="additional-field-info-control-title">
      {{ $t('common.title.additional_field_info') }}
    </div>
    <div class="rows">
      <div v-if="!inputVal || inputVal.length === 0" class="no-additional-field-info-field">
        {{ $t('common.text.no_additional_field_info') }}
      </div>
      <draggable v-model="inputVal" draggable=".additional-field-info" :disabled="readonly || disabled">
        <div
          v-for="(additionalFieldInfo, additionalFieldInfoIndex) in inputVal"
          :key="additionalFieldInfoIndex"
          :class="['cols-xs-12', 'cols-sm-12', 'cols-md-12', 'cols-lg-12', 'cols-xl-12', 'additional-field-info', readonly || disabled? 'disabled' : '']"
        >
          <div class="additional-field-info-field-row">
            <div class="rows">
              <div class="cols-xs-12 cols-sm-12 cols-md-5 cols-lg-5 cols-xl-5">
                <input-control
                  v-model="additionalFieldInfo.nm"
                  :required="true"
                  type="i18n"
                  :name="'additional_field_info_nm'"
                  :readonly="readonly || additionalFieldInfo.bassFlag === 'Y' || !hasAuthority('update_' + item + '_metainfo')"
                  :disabled="disabled"
                />
              </div>
              <div class="cols-xs-10 cols-sm-10 cols-md-4 cols-lg-4 cols-xl-4">
                <input-control
                  v-model="additionalFieldInfo.valueTyCode"
                  :required="true"
                  type="select"
                  :options="valueTypeOptions"
                  :disabled="readonly || disabled || additionalFieldInfo.bassFlag === 'Y' || additionalFieldInfo.relatedDataCount > 0 || !hasAuthority('update_' + item + '_metainfo')"
                  :name="'value_ty_code'"
                />
                <input-control
                  v-if="purposeOptions && purposeOptions.length > 2"
                  v-model="additionalFieldInfo.prposCode"
                  :required="true"
                  type="select"
                  :options="purposeOptions"
                  :disabled="readonly || disabled || additionalFieldInfo.bassFlag === 'Y' || additionalFieldInfo.relatedDataCount > 0 || !hasAuthority('update_' + item + '_metainfo')"
                  :name="'prpos_code'"
                />
              </div>
              <div class="cols-xs-12 cols-sm-12 cols-md-2 cols-lg-2 cols-xl-2">
                <input-control
                  v-if="!isTitle(additionalFieldInfo.valueTyCode)"
                  v-model="additionalFieldInfo.essntlFlag"
                  type="checkbox"
                  :name="'essntl_flag'"
                  :readonly="readonly || additionalFieldInfo.bassFlag === 'Y' || additionalFieldInfo.relatedDataCount > 0 || !hasAuthority('update_' + item + '_metainfo')"
                  :disabled="disabled"
                />
                <div v-else>
                  &nbsp;
                </div>
              </div>
              <div class="cols-xs-2 cols-sm-2 cols-md-1 cols-lg-1 cols-xl-1 delete-button-area">
                <button v-if="!(readonly || disabled || additionalFieldInfo.bassFlag === 'Y' || !hasAuthority('update_' + item + '_metainfo'))" class="btn" @click="removeAdditionalFieldInfoField(additionalFieldInfo)">
                  <i class="fa fa-remove" />
                </button>
              </div>
              <div class="clear" />
            </div>
            <div v-if="additionalFieldInfo.valueTyCode === 'value_type.multifile' || additionalFieldInfo.valueTyCode === 'value_type.singlefile'">
              <input-control
                v-model="additionalFieldInfo.optn.fileInfo.purpose"
                type="select"
                :name="'value_' + additionalFieldInfoIndex + '_purpose'"
                :required="true"
                :options="[
                  {value: '', text:$t('common.placeholder.select')},
                  {value: 'file_purpose.thumb', text:$t('code.nm.file_purpose.thumb')},
                  {value: 'file_purpose.general', text:$t('code.nm.file_purpose.general')}
                ]"
                :title="$t('code_group.nm.file_purpose')"
                :readonly="readonly || additionalFieldInfo.bassFlag === 'Y' || additionalFieldInfo.relatedDataCount > 0 || !hasAuthority('update_' + item + '_metainfo')"
                :disabled="disabled"
              />
              <input-control
                v-model="additionalFieldInfo.optn.fileInfo.accept"
                type="text"
                :name="'value_' + additionalFieldInfoIndex + '_accept'"
                :title="$t('file.text.accept')"
                :readonly="readonly || additionalFieldInfo.bassFlag === 'Y' || additionalFieldInfo.relatedDataCount > 0 || !hasAuthority('update_' + item + '_metainfo')"
                :disabled="disabled"
              />
              <pig-tail-label :message="$t('file.notification.accept')" />

              <input-control
                v-model="additionalFieldInfo.optn.fileInfo.usePromary"
                type="checkbox"
                :name="'value_' + additionalFieldInfoIndex + '_usePrimary'"
                :title="$t('file.text.enable_primary')"
                :readonly="readonly || additionalFieldInfo.bassFlag === 'Y' || !hasAuthority('update_' + item + '_metainfo')"
                :disabled="disabled"
              />

              <input-control
                v-model="additionalFieldInfo.optn.fileInfo.securityType"
                type="select"
                :name="'value_' + additionalFieldInfoIndex + '_securityType'"
                :required="true"
                :options="[
                  {value: '', text:$t('common.placeholder.select')},
                  {value: 'file_security_type.open', text:$t('code.nm.file_security_type.open')},
                  {value: 'file_security_type.mine', text:$t('code.nm.file_security_type.mine')}
                ]"
                :title="$t('code_group.nm.file_security_type')"
                :readonly="readonly || additionalFieldInfo.bassFlag === 'Y' || additionalFieldInfo.relatedDataCount > 0 || !hasAuthority('update_' + item + '_metainfo')"
                :disabled="disabled"
              />

              <input-control
                v-if="additionalFieldInfo.valueTyCode === 'value_type.multifile'"
                v-model="additionalFieldInfo.optn.fileInfo.maxFiles"
                type="number"
                :name="'value_' + additionalFieldInfoIndex + '_maxFiles'"
                :title="$t('file.text.max_files')"
                :readonly="readonly || additionalFieldInfo.bassFlag === 'Y' || !hasAuthority('update_' + item + '_metainfo')"
                :disabled="disabled"
              />
            </div>
            <div v-else-if="additionalFieldInfo.valueTyCode === 'value_type.select' || additionalFieldInfo.valueTyCode === 'value_type.multiselect' || additionalFieldInfo.valueTyCode === 'value_type.multiselect_list'" class="option-area">
              {{ $t('common.label.option') }}
              <div class="select-options-area">
                <input-control
                  v-model="additionalFieldInfo.optn.multilanguage"
                  type="checkbox"
                  :disabled="readonly || disabled || additionalFieldInfo.bassFlag === 'Y' || additionalFieldInfo.relatedDataCount > 0 || !hasAuthority('update_' + item + '_metainfo')"
                  :name="'support_multilanguage'"
                />
                <div v-if="!additionalFieldInfo.optn.options || additionalFieldInfo.optn.options.length === 0" class="no-options">
                  {{ $t('common.text.no_option') }}
                </div>

                <draggable v-model="additionalFieldInfo.optn.options" draggable=".options-area" :disabled="readonly || disabled">
                  <div v-for="(option, optionIndex) in additionalFieldInfo.optn.options" :key="optionIndex" :class="{'rows': true, 'options-area': true, 'disabled': readonly || disabled}">
                    <div class="cols-xs-12 cols-sm-12 cols-md-5 cols-lg-5 cols-xl-5">
                      <multilanguage-text-converter-control
                        v-model="option.text"
                        :multilanguage="additionalFieldInfo.optn.multilanguage"
                        :name="'text_' + additionalFieldInfoIndex + '_' + optionIndex"
                        :title="$t('common.label.text')"
                        :required="true"
                        :readonly="readonly || additionalFieldInfo.bassFlag === 'Y' || !hasAuthority('update_' + item + '_metainfo')"
                        :disabled="disabled"
                      />
                    </div>
                    <div class="cols-xs-10 cols-sm-10 cols-md-5 cols-lg-5 cols-xl-5">
                      <input-control
                        v-model="option.value"
                        type="text"
                        :name="'value_' + additionalFieldInfoIndex + '_' + optionIndex"
                        :title="$t('common.label.value')"
                        :readonly="readonly || additionalFieldInfo.bassFlag === 'Y' || additionalFieldInfo.relatedDataCount > 0 || !hasAuthority('update_' + item + '_metainfo')"
                        :disabled="disabled"
                      />
                    </div>
                    <div class="cols-xs-2 cols-sm-2 cols-md-2 cols-lg-2 cols-xl-2 delete-button-area">
                      <button v-if="!(readonly || disabled || additionalFieldInfo.bassFlag === 'Y' || additionalFieldInfo.relatedDataCount > 0 || !hasAuthority('update_' + item + '_metainfo'))" class="btn" @click="removeOption(option, additionalFieldInfo.optn.options)">
                        <i class="fa fa-remove" />
                      </button>
                    </div>
                    <div class="clear" />
                  </div>
                </draggable>
                <div v-if="!(readonly || disabled || additionalFieldInfo.bassFlag === 'Y' || !hasAuthority('update_' + item + '_metainfo'))" class="add-button-area">
                  <button class="btn btn-primary" @click="addOption(additionalFieldInfo.optn.options)">
                    {{ $t('common.button.add_option') }}
                  </button>
                </div>
              </div>
            </div>
            <pig-tail-label v-if="additionalFieldInfo.bassFlag === 'Y'" :message="$t('common.tooltip.cannot_update_system_default_data')" />
            <pig-tail-label v-else-if="additionalFieldInfo.relatedDataCount > 0" :message="$t('common.tooltip.cannot_update_saved_data')" />
          </div>
        </div>
      </draggable>
    </div>
    <div v-if="!(readonly || disabled || !hasAuthority('update_' + item + '_metainfo'))" class="add-button-area">
      <button class="btn btn-primary" @click="addAdditionalFieldInfoField">
        {{ $t('common.button.add_additional_field_info') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    module: {
      type: String,
      required: true
    },
    item: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      inputVal: undefined,
      purposeOptions: [
        {
          text: this.$t('code_group.nm.additional_field_purpose'),
          value: ''
        },
        {
          text: this.$t('code.nm.additional_field_purpose.user_input'),
          value: 'additional_field_purpose.user_input'
        }
      ],
      valueTypeOptions: []
    }
  },
  computed: {
    hasError() {
      return this.errors.has(this.name)
    },
    computedRules: function() {
      return 'required'
    }
  },
  watch: {
    value: function(newVal) {
      this.inputVal = newVal
    },
    inputVal: {
      handler(newVal, oldVal) {
        this.$nextTick(() => {
          this.$emit('input', newVal)
          this.$emit('change', newVal)
          this.$emit('forceUpdate')
        })
      },
      deep: true
    }
  },
  mounted() {
    this.valueTypeOptions.push({
      text: this.$t('code_group.nm.value_type'),
      value: ''
    })
    if (this.configs && this.configs.valueTypes) {
      for (let i = 0; i < this.configs.valueTypes.length; i++) {
        this.valueTypeOptions.push({
          text: this.$t(this.configs.valueTypes[i].nm),
          value: this.configs.valueTypes[i].code
        })
      }
    }
    if (this.value) {
      if (!window._additionalFieldInfoControlId) {
        window._additionalFieldInfoControlId = 1
      }
      for (let i = 0; i < this.value.length; i++) {
        this.value[i].id = window._additionalFieldInfoControlId
        window._additionalFieldInfoControlId++
      }
    }
    this.inputVal = this.value
  },
  methods: {
    isTitle(valueType) {
      if (valueType === 'value_type.title') {
        return true
      }
      if (valueType === 'value_type.subtitle_lv1') {
        return true
      }
      if (valueType === 'value_type.subtitle_lv2') {
        return true
      }
      if (valueType === 'value_type.subtitle_lv3') {
        return true
      }
      if (valueType === 'value_type.subtitle_lv4') {
        return true
      }
      return false
    },
    addAdditionalFieldInfoField() {
      if (!window._additionalFieldInfoControlId) {
        window._additionalFieldInfoControlId = 1
      }
      let prposCode = ''
      if (this.purposeOptions && this.purposeOptions.length === 2) {
        prposCode = this.purposeOptions[1].value
      }
      this.inputVal.push({
        id: window._additionalFieldInfoControlId,
        prposCode: prposCode,
        valueTyCode: '',
        optn: {
          multilanguage: false,
          options: [],
          fileInfo: {}
        }
      })
      window._additionalFieldInfoControlId++
    },
    removeAdditionalFieldInfoField(target) {
      for (let i = 0; i < this.inputVal.length; i++) {
        if (this.inputVal[i] === target) {
          this.inputVal.splice(i, 1)
          break
        }
      }
    },
    addOption(options) {
      options.push({
        value: '',
        text: ''
      })
    },
    removeOption(option, options) {
      for (let i = 0; i < options.length; i++) {
        if (options[i] === option) {
          options.splice(i, 1)
          break
        }
      }
    }
  }
}
</script>

<style scoped>
.additional-field-info-control {
  padding: 15px;
  margin-top: 15px;
  margin-bottom: 15px;
}
.additional-field-info-field-row {
  border: 1px solid #cccccc;
  padding-top: 10px;
  padding-left: 15px;
  padding-right: 15px;
  margin-bottom: 10px;
  margin-left: 0;
  margin-right: 0;
}
.option-area {
  border: 1px solid #cccccc;
  padding: 10px 15px;
  margin-bottom: 15px;
}
.additional-field-info-control-title {
  font-weight: bold;
  margin-bottom: 10px;
}
.add-button-area,
.delete-button-area {
  text-align: right;
}
.no-additional-field-info-field {
  border: 1px solid #cccccc;
  text-align: center;
  padding: 50px;
  margin-bottom: 10px;
  margin-left: 15px;
  margin-right: 15px;
}
.select-options-area {
  margin-top: 10px;
}
.options-area {
  cursor: move;
}
.options-area.disabled {
  cursor: auto;
}
.no-options,
.options-area {
  border: 1px solid #cccccc;
  margin-bottom: 10px;
}
.options-area {
  margin-left: 0px;
  margin-right: 0px;
  padding: 15px;
  padding-bottom: 0;
}
.no-options {
  text-align: center;
  padding: 50px;
}
.additional-field-info {
  cursor: move;
}
.additional-field-info.disabled {
  cursor: auto;
}
</style>
